module.exports = __webpack_public_path__ + "static/media/lila.796b164e.jpg";